import React from 'react';
import { globalThisPolyfill } from '@formily/shared';
var env = {
    portalDOM: null,
    ReactDOM: null,
};
export var render = function (element) {
    var _a;
    if (((_a = globalThisPolyfill.navigator) === null || _a === void 0 ? void 0 : _a.product) === 'ReactNative')
        return null;
    if (globalThisPolyfill.document) {
        env.portalDOM =
            env.portalDOM || globalThisPolyfill['document'].createElement('div');
        env.ReactDOM =
            env.ReactDOM || globalThisPolyfill['ReactDOM'] || require('react-dom');
        //eslint-disable-next-line
        return env.ReactDOM.createPortal(element, env.portalDOM);
    }
    else {
        return React.createElement('template', {}, element);
    }
};
//# sourceMappingURL=render.js.map